// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.add-value-form-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  margin-bottom: 8px;
  background: #f9f9f9;
  border: 1px solid 1px solid #ededee;
  border-radius: 4px;
}

.add-form-field {
  width: 200px;
}
.add-form-field--value {
  width: 280px;
}

.add-form-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  padding-top: 4px;
}

.add-form-error {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #97002e;
  font-size: 0.875rem;
}
.add-form-error mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
